import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-stone-50">
      {/* Header */}
      <header className="bg-white border-b border-stone-200">
        <nav className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 rounded-full bg-sage-600 flex items-center justify-center text-white font-bold">
                SM
              </div>
              <div>
                <div className="font-semibold text-stone-900">Samuel Magalhães</div>
                <div className="text-xs text-stone-600">Medicina Tradicional Chinesa</div>
              </div>
            </div>
            <Button onClick={() => navigate('/')} variant="outline" className="border-sage-600 text-sage-700">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Voltar ao Site
            </Button>
          </div>
        </nav>
      </header>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-stone-900 mb-6">Termos de Utilização</h1>
            <p className="text-stone-600 mb-8">Última atualização: Janeiro de 2025</p>

            <div className="space-y-8">
              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>1. Aceitação dos Termos</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Ao aceder e utilizar este website, você aceita e concorda em cumprir estes Termos de Utilização. Se não concordar com qualquer parte destes termos, não deve utilizar este website.
                  </p>
                  <p>
                    Estes termos aplicam-se a todos os visitantes, utilizadores e outras pessoas que acedam ao website de Samuel Magalhães, terapeuta de Medicina Tradicional Chinesa.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>2. Descrição dos Serviços</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Este website fornece informações sobre serviços de Medicina Tradicional Chinesa, incluindo:
                  </p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Acupuntura</li>
                    <li>Shiatsu</li>
                    <li>Craniopuntura YNSA</li>
                    <li>Auriculoterapia</li>
                    <li>Reflexologia</li>
                    <li>Tui-Na</li>
                  </ul>
                  <p>
                    O website permite solicitar marcações de consultas, subscrever newsletters e preencher formulários de avaliação.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>3. Utilização do Website</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>Ao utilizar este website, compromete-se a:</p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Fornecer informações verdadeiras, precisas e completas</li>
                    <li>Manter a confidencialidade das suas credenciais de acesso (se aplicável)</li>
                    <li>Não utilizar o website para fins ilegais ou não autorizados</li>
                    <li>Não tentar aceder a áreas restritas do website</li>
                    <li>Não transmitir vírus, malware ou qualquer código malicioso</li>
                    <li>Não copiar, modificar ou distribuir conteúdo do website sem autorização</li>
                  </ul>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>4. Marcação de Consultas</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Os pedidos de marcação submetidos através do website estão sujeitos a confirmação. A submissão de um formulário de marcação não garante a disponibilidade ou confirmação automática da consulta.
                  </p>
                  <p>
                    Entraremos em contacto consigo através do email ou telefone fornecido para confirmar a marcação.
                  </p>
                  <p>
                    <strong>Política de Cancelamento:</strong> Solicitamos que cancele ou reagende consultas com pelo menos 24 horas de antecedência, contactando-nos por telefone ou email.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>5. Informações sobre Saúde</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    <strong>Aviso Importante:</strong> As informações fornecidas neste website têm caráter informativo e educacional. Não substituem o aconselhamento, diagnóstico ou tratamento médico profissional.
                  </p>
                  <p>
                    A Medicina Tradicional Chinesa é uma terapia complementar. Recomendamos que:
                  </p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Consulte sempre o seu médico antes de iniciar qualquer tratamento</li>
                    <li>Informe o terapeuta sobre quaisquer condições médicas, medicamentos ou alergias</li>
                    <li>Continue a seguir as recomendações do seu médico</li>
                    <li>Não interrompa tratamentos médicos sem orientação profissional</li>
                  </ul>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>6. Propriedade Intelectual</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Todo o conteúdo deste website, incluindo textos, gráficos, logotipos, imagens, vídeos e software, é propriedade de Samuel Magalhães ou dos seus licenciadores e está protegido por leis de direitos de autor portuguesas e internacionais.
                  </p>
                  <p>
                    É proibido copiar, reproduzir, distribuir, publicar ou modificar qualquer conteúdo do website sem autorização prévia por escrito.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>7. Links para Websites de Terceiros</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Este website pode conter links para websites de terceiros. Estes links são fornecidos apenas para sua conveniência. Não temos controlo sobre o conteúdo desses websites e não somos responsáveis pelo seu conteúdo ou práticas de privacidade.
                  </p>
                  <p>
                    A inclusão de links não implica aprovação ou associação com esses websites.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>8. Limitação de Responsabilidade</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Na medida máxima permitida por lei, Samuel Magalhães não será responsável por:
                  </p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Danos diretos, indiretos, incidentais ou consequenciais resultantes do uso ou incapacidade de usar o website</li>
                    <li>Erros ou omissões no conteúdo do website</li>
                    <li>Interrupções, vírus ou problemas técnicos do website</li>
                    <li>Perda de dados ou lucros relacionados com o uso do website</li>
                  </ul>
                  <p>
                    O website é fornecido "tal como está" e "conforme disponível", sem garantias de qualquer tipo.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>9. Indemnização</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Você concorda em indemnizar e isentar Samuel Magalhães de quaisquer reclamações, danos, perdas, responsabilidades e despesas (incluindo honorários advocatícios) decorrentes:
                  </p>
                  <ul className="list-disc pl-6 space-y-2">
                    <li>Do seu uso do website</li>
                    <li>Da violação destes Termos de Utilização</li>
                    <li>Da violação de direitos de terceiros</li>
                  </ul>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>10. Privacidade e Proteção de Dados</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    A recolha e utilização dos seus dados pessoais está sujeita à nossa Política de Privacidade, que cumpre o RGPD (Regulamento Geral sobre a Proteção de Dados) e a Lei n.º 58/2019.
                  </p>
                  <p>
                    Ao utilizar este website, você consente com a recolha e utilização de informações de acordo com a Política de Privacidade.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>11. Rescisão</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Reservamo-nos o direito de suspender ou terminar o seu acesso ao website, sem aviso prévio, se violar estes Termos de Utilização ou se considerarmos que o seu comportamento é prejudicial para outros utilizadores ou para o website.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>12. Modificações dos Termos</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Reservamo-nos o direito de modificar estes Termos de Utilização a qualquer momento. As alterações serão publicadas nesta página com a data de atualização revista.
                  </p>
                  <p>
                    É da sua responsabilidade rever periodicamente estes termos. O uso continuado do website após a publicação de alterações constitui a sua aceitação dos novos termos.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>13. Lei Aplicável e Jurisdição</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Estes Termos de Utilização são regidos e interpretados de acordo com as leis de Portugal.
                  </p>
                  <p>
                    Qualquer disputa relacionada com estes termos ou com o uso do website será da competência exclusiva dos tribunais portugueses.
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>14. Livro de Reclamações</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Em conformidade com a legislação portuguesa, disponibilizamos o acesso ao Livro de Reclamações Eletrónico através do portal:
                  </p>
                  <p>
                    <a href="https://www.livroreclamacoes.pt" target="_blank" rel="noopener noreferrer" className="text-sage-600 hover:text-sage-700 font-semibold">
                      www.livroreclamacoes.pt
                    </a>
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>15. Contacto</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Para questões sobre estes Termos de Utilização, contacte:
                  </p>
                  <p>
                    <strong>Samuel Magalhães</strong><br />
                    Email: samuelmagalhaes.mtc@gmail.com<br />
                    Telefone: 961 509 484<br />
                    Locais de atendimento: Porto e Braga, Portugal
                  </p>
                </CardContent>
              </Card>

              <Card className="border-none shadow-sm">
                <CardHeader>
                  <CardTitle>16. Disposições Gerais</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4 text-stone-700">
                  <p>
                    Se qualquer disposição destes Termos de Utilização for considerada inválida ou inexequível, as restantes disposições permanecerão em vigor.
                  </p>
                  <p>
                    O não exercício de qualquer direito previsto nestes termos não constitui renúncia a esse direito.
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-stone-900 text-stone-300 py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm">© 2025 Samuel Magalhães - Terapeuta de Medicina Tradicional Chinesa</p>
          <p className="text-xs text-stone-500 mt-2">Porto | Braga | Portugal</p>
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;